import React, { useEffect, useRef, useState } from "react";
import { gl_start } from "./webgl";

function Scene() {
this.vertexShader = `#version 300 es
in vec3 aPos;
out vec3 vPos;

void main() {
    vPos = aPos;
    gl_Position = vec4(aPos, 1.0);
}
`;

this.fragmentShader = `#version 300 es
precision mediump float;
out vec4 fragColor;

uniform float u_time;

void main() {
    fragColor = vec4(abs(sin(u_time)),0.0,0.0,1.0);
}
`;
}

export default () => {
    const canvasRef = useRef(null);
    const [code, setCode] = useState("");
    const [uTime, setUTime] = useState(0); // Initialize uTime state

    useEffect( () => {
        const scene = new Scene();
        // gl_start will initialize WebGL and start the draw loop; it sets a global `gl`
        // and doesn't reliably return it synchronously, so we don't expect a value here.
                const gl = gl_start(canvasRef.current, scene); // Initialize WebGL and get context

        // helper to inject current u_time value as a comment next to the uniform declaration
        const injectUTime = (fragSrc, seconds) => {
            return fragSrc.replace(/uniform\s+float\s+u_time\s*;/, `uniform float u_time; // ${seconds.toFixed(2)}`);
        };

        setCode(`Vertex Shader\n${scene.vertexShader}\nFragment Shader\n${injectUTime(scene.fragmentShader, 0)}`);

        // U_TIME
        if (canvasRef.current) {
            canvasRef.current._onFrame = (seconds) => {
                // set short precision for display and inject uTime comment into shader source
                const fragWithTime = injectUTime(scene.fragmentShader, seconds);
                setCode(`Vertex Shader\n${scene.vertexShader}\nFragment Shader\n${fragWithTime}`);
                setUTime(seconds);
            };
        }

        return () => {
            if (canvasRef.current && typeof canvasRef.current.stopRender === 'function') canvasRef.current.stopRender();
            if (canvasRef.current) canvasRef.current._onFrame = null; // Cleanup the onFrame callback
        };
    }, []);
    
    return (
        <div style = { { position: "relative", display: "flex", justifyContent: "center", marginBottom: 20, gap : "16px" } }>
            <canvas ref = {canvasRef} width={400} height={400} />
            <pre>{ code }</pre>
        </div>
    );
}